import React from 'react'
import { toast } from 'react-toastify'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import _ from 'lodash'

import config from '../../../config'
import withReduxModal from '../../../modules/redux-modal/redux/withReduxModal'
import { IMAGE_EDIT_MODAL } from '../../../constants/modalType'
import {
  UPDATE_CONTRIBUTOR_IMAGE,
  ADD_CONTRIBUTOR_IMAGE,
} from '../../../constants/actions'

class ContributorItemImage extends React.Component {
  handleDropFile = e => {
    e.preventDefault()
    const files = e.target.files
    const imageFile = files[0]
    this.handleEditImageModelShow(imageFile)
  }

  componentDidUpdate(props) {
    if (!_.isEqual(props.mainImageId, this.props.mainImageId)) {
      this.props.onImageChange(this.props.mainImageId)
    }
  }

  handleImagePicked = imageFile => {
    this.handleEditImageModelShow(imageFile)
  }

  handleEditImageModelShow = imageFile => {
    if (imageFile) {
      this.props.modalActions.showModal(IMAGE_EDIT_MODAL, {
        imageFile,
        replaceImageID: this.props.mainImageId,
        action: this.props.mainImageId
          ? UPDATE_CONTRIBUTOR_IMAGE
          : ADD_CONTRIBUTOR_IMAGE,
        imageAspectRatio: 1,
      })
    } else {
      toast.error('image file not found.')
    }
  }

  render() {
    const {
      mainImageId,
      mainImageLastChecked,
      originalMainImageId,
    } = this.props
    const imageId = originalMainImageId || mainImageId

    return (
      <div>
        {imageId && (
          <figure className="image is-128x128">
            <img
              src={`${
                config.imageURLPrefix
              }/${imageId}?lastChecked=${mainImageLastChecked ||
                new Date().toISOString()}`}
              alt={imageId}
            />
          </figure>
        )}
        <div className="field">
          <div className="file is-info">
            <label className="file-label">
              <input
                className="file-input"
                type="file"
                name="files"
                onChange={this.handleDropFile}
              />
              <span className="file-cta">
                <span className="file-icon">
                  <i className="fas fa-upload" />
                </span>
                <span className="file-label">Local file…</span>
              </span>
            </label>
          </div>
        </div>
      </div>
    )
  }
}

export default compose(
  withReduxModal,
  connect(({ contributor: { mainImageId } }) => ({ mainImageId })),
)(ContributorItemImage)



// WEBPACK FOOTER //
// ./src/components/templates/contributor-item/ContributorItemImage.js